export const openBlobInNewTabAndPrint = (blob: Blob) => {
  const blobUrl = URL.createObjectURL(blob);
  const win = window.open(blobUrl, '_blank');
  win?.addEventListener('load', () => {
    win.print();
    win.onafterprint = () => {
      URL.revokeObjectURL(blobUrl); // важно очищать
      win.close();
    };
  });
};
